"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const bem_helper_1 = require("../../helpers/bem-helper");
const DialogContentContainerConstants_1 = require("./DialogContentContainerConstants");
require("./DialogContentContainer.scss");
const bemHelper = (0, bem_helper_1.BEMClass)("dialog-content-container");
const DialogContentContainer = (0, react_1.forwardRef)(({ className = "", ariaLabelledby = "", ariaDescribedby = "", type = DialogContentContainerConstants_1.DialogType.POPOVER, size = DialogContentContainerConstants_1.DialogSize.MEDIUM, children, style }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ role: "dialog", "aria-labelledby": ariaLabelledby, "aria-describedby": ariaDescribedby, ref: mergedRef, style: style, className: (0, classnames_1.default)("dialog-content-container", className, bemHelper({ state: type }), bemHelper({ state: size })) }, { children: children })));
});
Object.assign(DialogContentContainer, {
    types: DialogContentContainerConstants_1.DialogType,
    sizes: DialogContentContainerConstants_1.DialogSize
});
exports.default = DialogContentContainer;
